
const PRIMARY_BLUE = "#007BBB";

const customMultiSelectStyles = {
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  menu: (base) => ({
    ...base,
    width: "auto",
    minWidth: "100%",
    background: "white",
  }),
  clearIndicator: () => ({
      display: "none",
  }),
  control: (base, state) => ({
      ...base,
      boxShadow: "none",
      borderColor: "#ccc",
      "&:hover": {
          borderColor: "#ccc",
      },
  }),
  option: (base, state) => ({
      ...base,
      width: "100%",
    }),
  multiValue: (base) => ({
      ...base,
      background: "#007BBB",
      display: "inline-flex",
      color: "white",
      borderRadius: "11px",
      alignItems: "center",
      justifyContent: "center",
      margin: "2px 2px 2px 0px",
  }),
  multiValueLabel: (base) => ({
      ...base,
      fontSize: "13px",
      color: "white",
      padding: "4px 4px 4px 10px",
      lineHeight: "1.2",
      display: "flex",
      alignItems: "center",
      marginRight: "0",
  }),
  multiValueRemove: (base) => ({
      ...base,
      background: "#007BBB",
      color: "white",
      borderRadius: "0 11px 11px 0",
      padding: "0 6px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
          background: "#0066a3",
          color: "white",
      },
  })
  // container: (base) => ({
  //   ...base,
  //   width: "100%",
  // }),
  // control: (base, state) => ({
  //   ...base,
  //   minHeight: "32px",
  //   // borderColor: PRIMARY_BLUE,
  //   boxShadow: state.isFocused ? `0 0 0 1px ${PRIMARY_BLUE}` : base.boxShadow,
  //   // "&:hover": {
  //   //   borderColor: None,
  //   // },
  // }),
  // menu: (base) => ({
  //   ...base,
  //   width: "fit-content",
  //   background: "white",
  // }),
  // option: (base, state) => ({
  //   ...base,
  //   backgroundColor: state.isFocused || state.isSelected ? PRIMARY_BLUE : "white",
  //   color: state.isFocused || state.isSelected ? "white" : base.color,
  //   cursor: "pointer",
  //   "&:active": {
  //     backgroundColor: PRIMARY_BLUE,
  //     color: "white",
  //   },
  // }),
  // multiValue: (base) => ({
  //   ...base,
  //   background: PRIMARY_BLUE,
  //   display: "inline-flex",
  //   color: "white",
  //   borderRadius: "11px",
  //   alignItems: "center",
  //   margin: "2px",
  // }),
  // multiValueLabel: (base) => ({
  //   ...base,
  //   fontSize: "13px",
  //   color: "white",
  //   padding: "4px 10px 4px 10px",
  // }),
  // multiValueRemove: (base) => ({
  //   ...base,
  //   background: PRIMARY_BLUE,
  //   color: "white",
  //   "&:hover": {
  //     background: PRIMARY_BLUE,
  //     color: "white",
  //   },
  // }),
};

const customMultiSelectStylesV2 = {
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "32px",
    borderColor: PRIMARY_BLUE,
    boxShadow: state.isFocused ? `0 0 0 1px ${PRIMARY_BLUE}` : base.boxShadow,
    "&:hover": {
      borderColor: PRIMARY_BLUE,
    },
  }),
  multiValue: (base) => ({
    ...base,
    background: PRIMARY_BLUE,
    display: "inline-flex",
    color: "white",
    borderRadius: "11px",
    alignItems: "center",
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontSize: "13px",
    color: "white",
    padding: "2px 4px 2px 4px",
  }),
};

const customSingleSelectStyles = {
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  menu: (base) => ({
    ...base,
    width: "100%",
    minWidth: "100%",
    background: "white",
  }),
  control: (base, state) => {
    const hasValue = !!state.selectProps.value;
    return {
      ...base,
      minHeight: "32px",
      borderColor: PRIMARY_BLUE,
      backgroundColor: hasValue ? PRIMARY_BLUE : base.backgroundColor,
      boxShadow: state.isFocused ? `0 0 0 1px ${PRIMARY_BLUE}` : base.boxShadow,
      "&:hover": {
        borderColor: PRIMARY_BLUE,
      },
    };
  },
  singleValue: (base, state) => {
    const hasValue = !!state.selectProps.value;
    return {
      ...base,
      color: hasValue ? "white" : base.color,
    };
  },
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
  }),
  dropdownIndicator: (base, state) => {
    const hasValue = !!state.selectProps.value;
    return {
      ...base,
      color: hasValue ? "white" : base.color,
      "&:hover": {
        color: hasValue ? "white" : base.color,
      },
    };
  },
  indicatorSeparator: (base, state) => {
    const hasValue = !!state.selectProps.value;
    return {
      ...base,
      backgroundColor: hasValue ? "white" : base.backgroundColor,
    };
  },
};

export { customMultiSelectStyles, customMultiSelectStylesV2, customSingleSelectStyles };
